"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* istanbul ignore file */

var createStorage = function createStorage(provider) {
  return {
    get: function get(key, defaultValue) {
      var json = provider.getItem(key);

      if (!json) {
        return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
      }

      return JSON.parse(json);
    },
    set: function set(key, value) {
      provider.setItem(key, JSON.stringify(value));
    }
  };
};

var _default = createStorage;
exports["default"] = _default;